/* eslint-disable max-len */

import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import { REMOTE_COLLECTION } from '../apiUrls';
import { buildUrl, replaceParameters } from '@/common-utils/functions/restUtils';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import transactionsFields from '../../fields/transactionsFields';

/**
 * @param responseData response.data object
 * @param responseData.items
 * @param responseData.totalResults
 * @param responseData.extraInformation
 * @returns Mapped data object
 */
function mapResponseData({ items, totalResults, extraInformation }) {
    const data = {};

    const mappedItems = items.map(item => {
        return {
            [transactionsFields.UUID.key]: item[transactionsFields.UUID.key],
            [transactionsFields.ORIGIN_APPLICATION.key]: item[transactionsFields.ORIGIN_APPLICATION.key],
            [transactionsFields.LOCAL_TRANSACTION_DATE_TIME.key]: item[transactionsFields.LOCAL_TRANSACTION_DATE_TIME.key],
            [transactionsFields.EXPIRATION_DATE.key]: item[transactionsFields.EXPIRATION_DATE.key],
            [transactionsFields.APPLICATION.key]: item[transactionsFields.APPLICATION.key],
            [transactionsFields.EVENT_TYPE.key]: item[transactionsFields.EVENT_TYPE.key],
            [transactionsFields.AMOUNT.key]: item[transactionsFields.AMOUNT.key],
            [transactionsFields.CONTRACT.key]: item[transactionsFields.CONTRACT.key],
            [transactionsFields.AUTHORIZATION_NUMBER.key]: item[transactionsFields.AUTHORIZATION_NUMBER.key],
            [transactionsFields.AUTHORIZATION_CODE_RESULT.key]: item[transactionsFields.AUTHORIZATION_CODE_RESULT.key],
            [transactionsFields.AUTHORIZATION_CODE.key]: item[transactionsFields.AUTHORIZATION_CODE.key],
            [transactionsFields.FILE_NUMBER.key]: item[transactionsFields.FILE_NUMBER.key],
            [transactionsFields.POS_REMITTANCE_NUMBER.key]: item[transactionsFields.POS_REMITTANCE_NUMBER.key],
            [transactionsFields.RANK.key]: item[transactionsFields.RANK.key],
            [transactionsFields.RECONCILIATION_NUMBER.key]: item[transactionsFields.RECONCILIATION_NUMBER.key],
            [transactionsFields.REGISTRATION_NUMBER.key]: item[transactionsFields.REGISTRATION_NUMBER.key],
            [transactionsFields.TYPE.key]: item[transactionsFields.TYPE.key],
            [transactionsFields.BANK_CODE.key]: item[transactionsFields.BANK_CODE.key],
            [transactionsFields.LEGAL_NAME.key]: item[transactionsFields.LEGAL_NAME.key],
            [transactionsFields.EMERGENCY_STATUS.key]: item[transactionsFields.EMERGENCY_STATUS.key],
            [transactionsFields.PAN.key]: item[transactionsFields.PAN.key],
            [transactionsFields.CARD_DETAILS.key]: {
                [transactionsFields.CARD_DETAILS.PRODUCT.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(transactionsFields.CARD_DETAILS.PRODUCT)),
                [transactionsFields.CARD_DETAILS.TYPE.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(transactionsFields.CARD_DETAILS.TYPE))
            },
            [transactionsFields.POS_TERMINAL.key]: {
                [transactionsFields.POS_TERMINAL.UUID.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(transactionsFields.POS_TERMINAL.UUID)),
                [transactionsFields.POS_TERMINAL.LABEL.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(transactionsFields.POS_TERMINAL.LABEL)),
                [transactionsFields.POS_TERMINAL.SERIAL_NUMBER.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(transactionsFields.POS_TERMINAL.SERIAL_NUMBER)),
                [transactionsFields.POS_TERMINAL.MANUFACTURER.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(transactionsFields.POS_TERMINAL.MANUFACTURER))
            }
        };
    });

    data.items = mappedItems;
    data.totalResults = totalResults;
    data.extraInformation = extraInformation;
    return data;
}

const queryGetRemoteCollectionTransactions = (query, remoteCollectionsId, enabled) => {
    return {
        queryKey: [REMOTE_COLLECTION.TRANSACTIONS.COLLECTION.queryKey, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(replaceParameters(REMOTE_COLLECTION.TRANSACTIONS.COLLECTION.url, { remoteCollectionsId }), query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};


export default queryGetRemoteCollectionTransactions;